import { render, staticRenderFns } from "./ApplyLoan.vue?vue&type=template&id=10afeeb0&"
import script from "./ApplyLoan.vue?vue&type=script&lang=js&"
export * from "./ApplyLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports